import React from "react";
import ToolbarHOC from "../../components/Toolbar/ToolbarHOC";
import MobileNavigationItems from "../../components/Toolbar/NavigationItems/MobileNavigationItems";
import { Layout } from "antd";
import "./DefaultLayout.css";
import { Link } from "react-router-dom";
import { isMobileOnly } from "react-device-detect";
import AdminToolbar from "../../components/Admin/Toolbar/AdminToolbar";
import AdminMobileNavigationItems from "../../components/Admin/Toolbar/AdminNavigationItems/AdminMobileNavigationItems";
import AdminLayoutM3 from "../AdminLayoutM3/AdminLayoutM3";
import { isAdmin } from "../../helpers/utility";
const { Header, Content, Footer } = Layout;

function DefaultLayout({ children }) {
  const isAdminUser = isAdmin();

  /* Admin desktop: use M3-style layout (header + sidebar + content + footer) */
  if (isAdminUser && !isMobileOnly) {
    return <AdminLayoutM3>{children}</AdminLayoutM3>;
  }

  /* Vendor or admin mobile: original layout */
  return (
    <Layout className="layout">
      <Header className="layout-header">
        {isAdminUser ? <AdminToolbar /> : <ToolbarHOC />}
      </Header>
      <Content className="layout-body">{children}</Content>
      {isMobileOnly ? (
        isAdminUser ? (
          <AdminMobileNavigationItems />
        ) : (
          <MobileNavigationItems />
        )
      ) : (
        <Footer className="footer">
          Copyright © 2021 i4Strategies. All Rights Reserved |{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>
        </Footer>
      )}
    </Layout>
  );
}

export default DefaultLayout;
